<template>
  <ContentSection class="text-component">
    <Container
      indent="container-default sm:container-tighter"
      class="pt-6 md:pt-9"
    >
      <div
        class="prose-a:hover-underline-animation-prose list-styling prose prose-sm overflow-hidden prose-h2:pt-5 prose-ul:mt-6 xl:prose-lg"
        :class="$route.fullPath == '/erfolgsrechnung' ? 'erfolgsrechnung' : ''"
        v-html="data.text"
      />
    </Container>
  </ContentSection>
</template>

<script setup>
defineProps({
  data: { type: Object, required: true },
})
</script>

<style lang="scss">
.list-styling li p {
  margin-bottom: 0px;
  margin-top: 0px;
  @apply leading-snug;
}
.list-styling li {
  margin-bottom: 0.5rem;
  margin-top: 0px;
}
.list-styling ul {
  @apply mt-8;
}

table {
  @apply table-auto overflow-x-auto min-w-full block divide-y divide-gray-200;

  /* Hide scrollbar for Chrome, Safari and Opera */
  &::-webkit-scrollbar {
    display: none;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
  }

  tbody {
    @apply table divide-y divide-gray-200 bg-white min-w-full;
  }
}

.erfolgsrechnung {
  table {
    @apply mb-24;
    tbody {
      strong {
        @apply text-blue-500 font-normal #{!important};
      }

      // title
      th {
        strong {
          @apply uppercase font-medium tracking-wider text-blue-500 #{!important};
        }
      }
      td {
        vertical-align: middle !important;
      }
      tr:not(:has(td:nth-child(2):last-child)) {
        @apply border-blue-500 #{!important};
      }

      // if row is empty rm line form next element
      tr:has(td:nth-child(3) > p:empty):has(td:nth-child(2) > p:empty):has(
          td:nth-child(1) > p:empty
        ) {
        @apply h-12;
        & + tr {
          @apply border-none text-blue-500;
        }
      }
      // On moble align different (grid) only if table has 3 colls
      @media (max-width: 548px) {
        tr:not(:has(td:nth-child(2):last-child)) {
          @apply grid grid-cols-2;

          td {
            padding-top: 0.3rem !important;
            padding-bottom: 1.4rem !important;
          }
          td:first-of-type {
            @apply col-span-2;
            padding-bottom: 0.3rem !important;
            padding-top: 1.4rem !important;
          }
          // align cols
          &:first-of-type th:first-of-type {
            @apply hidden;
          }
        }
      }

      @media (min-width: 548px) {
        tr:not(:has(td:nth-child(2):last-child)) {
          & > td,
          & > th {
            &:nth-child(2) > p,
            &:nth-child(3) > p {
              @apply text-right;
            }
            &:nth-child(3) {
              @apply pr-0;
            }
          }
        }
      }
    }
    tbody > tr:last-child {
      @apply border-b-2 border-blue-500 text-blue-500;
      strong {
        @apply font-bold #{!important};
      }
    }
  }
}
</style>
